import React from 'react'
import RecommendedJobs from '../../../features/HomeAfterLogin.js/RecommendedJobs'
import { Footer } from '../../../features/footer/footer'
import { JobSearch } from '../../../features/jobSearch/jobSearch'
import { JobCategories } from '../../../features/jobCategories/jobCategories'
import { Testimonials } from '../../../features/testimonials/testimonials'
import CandidateMostActiveRecentJob from '../../../features/HomeAfterLogin.js/CandidateMostActiveRecentJobs/CandidateMostActiveRecentJob'
import { JobSearchRecommended } from '../../../features/jobSearch/jobSearchRecommended'
import { DownloadAppBanner } from '../DownloadAppBanner/DownloadAppBanner'
import Opportunity from '../../../features/HomeAfterLogin.js/Opportunity/Opportunity'

function HomeLoggedIn() {
  return (
    <div style={{
      background: "linear-gradient(90deg, rgba(119, 161, 211, 0.08), rgba(121, 203, 202, 0.03), rgba(254, 234, 234, 0.1))",
    }}
    >
      {/* <JobSearch /> */}
      <JobSearchRecommended />


      {/* <JobCategories />
      <Testimonials /> */}
      <RecommendedJobs />
      {/* <Opportunity /> */}
      <CandidateMostActiveRecentJob />
      <Footer />
      <DownloadAppBanner />
    </div>
  )
}

export default HomeLoggedIn
